<template>
  <div class="details">
    <form-title>基本信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="微信昵称">
            {{ result.wechatNickName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="学员电话">
            {{ result.mobilePhone }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="身份证号">
            {{ result.userIdCard }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="生成类型">
            {{ result.courseRegistrationId === -1 ? '手动创建':'自动生成' }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="课程名称">
            {{ result.courseName }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="证书类型">
            {{ courseTypeList.filter(v => v.value === result.certType).map(v=>v.label).join() }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="身份证正面">
            <el-image
              :src="result.frontPicUrl"
              :preview-src-list="[result.frontPicUrl,result.backPicUrl, result.headUrl]"
            />
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="身份证背面">
            <el-image
              :src="result.backPicUrl"
              :preview-src-list="[result.frontPicUrl,result.backPicUrl, result.headUrl]"
            />
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="头像">
            <el-image
              :src="result.headUrl"
              :preview-src-list="[result.certQrcodeUrl,result.certUrl, result.headUrl]"
            />
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>理论考试</form-title>
    <data-table
      :data="result.questionExamList"
      :table-column="tableColumn1"
    />
    <form-title>视频考试</form-title>
    <data-table
      :data="result.videoExamList"
      :table-column="tableColumn2"
      @buttonClick="buttonClick"
      @changeCheckbox="changeCheckbox"
    />
    <form-title
      class="flex"
    >
      线下视频考试
      <el-button
        type="primary"
        @click="openVideoOfflineDialog(activeOfflineItem)"
      >
        新增线下视频
      </el-button>
    </form-title>
    <data-table
      :data="result.offlineVideoList"
      :table-column="tableColumn3"
      @buttonClick="buttonClickOffline"
      @changeCheckbox="changeCheckboxOffline"
    />
    <form-title class="flex">
      证书查看
      <el-button
        type="primary"
        @click="openCertDialog"
      >
        编辑证书
      </el-button>
    </form-title>
    <el-row>
      <el-col :span="24">
        <info-item label="证书二维码">
          <el-image
            class="qr-code"
            :src="result.certQrcodeUrl"
            :preview-src-list="[result.certQrcodeUrl,result.certUrl]"
          />
        </info-item>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col :span="24">
        <info-item label="证书图片">
          <el-image
            :src="result.certUrl"
            :preview-src-list="[result.certQrcodeUrl,result.certUrl]"
          />
        </info-item>
      </el-col>
    </el-row>
    <video-dialog
      :dialog-visible.sync="vedioVisible"
      :item="activePlayItem"
    />
    <certDialog
      :dialog-visible.sync="certVisible"
      :item="result"
      @confirm="getInfo"
    />
    <offline-video-dialog
      :dialog-visible.sync="offlineDialogVisible"
      :item="activeOfflineItem"
      @confirm="getInfo"
      @close="()=> activeOfflineItem = {}"
    />
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import dataTable from '@/components/common/dataTable.vue';
import videoDialog from '@/components/common/videoDialog.vue';
import certDialog from '@/components/common/certDialog.vue';
import offlineVideoDialog from '@/components/common/offlineVideoDialog.vue';
import axClient from '@/services';
import types, { courseTypeList, examStatusList } from '@/config';

export default {
  name: 'AccountDetails',
  components: {
    formTitle,
    infoPanel,
    infoItem,
    videoDialog,
    certDialog,
    dataTable,
    offlineVideoDialog,
  },
  data() {
    return {
      types,
      courseTypeList,
      col: 5,
      vedioVisible: false,
      certVisible: false,
      offlineDialogVisible: false,
      activePlayItem: {},
      activeOfflineItem: {},
      result: {
        questionExamList: [],
        videoExamList: [],
      },
      tableColumn1: [
        {
          key: 'createTime',
          label: '考试时间',
          width: '200px',
          dataType: 'time',
        },
        {
          key: '',
          label: '考试类型',
          width: '160px',
          dataType: 'text',
          default: '理论考试',
        },
        {
          key: 'examUsedMinutes',
          label: '用时(分钟)',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'examScore',
          label: '得分',
          default: '无得分',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'examStatus',
          label: '结果',
          width: '160px',
          dataType: 'function',
          renderProps: '',
          render: (key) => examStatusList.filter((item) => item.value === key),
        },
      ],
      tableColumn2: [
        {
          key: 'lastRecordCreateTime',
          label: '考试时间',
          width: '200px',
          dataType: 'time',
        },
        {
          key: 'chapterLv1Name',
          label: '一级章节',
          width: '160px',
          dataType: 'text',
          default: '理论考试',
        },
        {
          key: 'chapterLv2Name',
          label: '二级章节',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'lastRecordExamScore',
          label: '得分',
          default: '无得分',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'isOnCert',
          label: '是否为证书上的视频',
          width: 'auto',
          dataType: 'component',
          renderProps: '',
          render: () => 'checkbox',
        },
        {
          key: 'control',
          label: '操作',
          dataType: 'component',
          renderProps: [
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
      tableColumn3: [
        {
          key: 'showCreateTime',
          label: '创建时间',
          width: '200px',
          dataType: 'time',
        },
        {
          key: 'showChapterName',
          label: '章节名称',
          width: '160px',
          dataType: 'text',
        },
        {
          key: 'remark',
          label: '视频备注',
          default: '无备注',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'isShow',
          label: '是否为证书上的视频',
          width: 'auto',
          dataType: 'component',
          renderProps: '',
          render: () => 'checkbox',
        },
        {
          key: 'control',
          label: '操作',
          dataType: 'component',
          renderProps: [
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 2, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.openVideo(item);
          break;
        default:
          break;
      }
    },
    // table 传递过来的按钮点击
    buttonClickOffline(type, item) {
      switch (type) {
        case 0:
          this.openVideoOffline(item);
          break;
        case 1:
          this.deleteVideoOffline(item);
          break;
        case 2:
          this.openVideoOfflineDialog(item);
          break;
        default:
          break;
      }
    },
    // 选择是否为证书上的视频
    async changeCheckbox(item) {
      await axClient.cert.updateIsOnCert({ id: item.videoExamRecord, isSomething: item.isOnCert });
      this.getInfo();
    },
    // 选择是否为证书上的视频
    async changeCheckboxOffline(item) {
      console.log(item);
      if (item.isShow === 1) {
        await axClient.cert.offlineVideoShow({ id: item.id });
      } else {
        await axClient.cert.offlineVideoHide({ id: item.id });
      }
      this.getInfo();
    },
    // 打开查看视频弹窗
    openVideo(item) {
      this.vedioVisible = true;
      this.activePlayItem.url = item.lastRecordVideoUrl;
    },
    // 打开查看视频弹窗 线下视频
    openVideoOffline(item) {
      this.vedioVisible = true;
      this.activePlayItem.url = item.videoUrl;
    },
    // 删除线下视频弹窗
    async deleteVideoOffline(item) {
      this.$confirm('确定删除该线下视频？', '删除线下视频', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const data = await axClient.cert.deleteVideoOffline({ id: item.id });
        if (data) {
          this.$message.success('删除成功');
          this.getInfo();
        }
      });
    },
    // 打开线下视频修改弹窗
    openVideoOfflineDialog(item) {
      this.activeOfflineItem = item;
      this.activeOfflineItem.userCourseCertId = this.result.id;
      this.offlineDialogVisible = true;
    },
    // 详情
    async getInfo() {
      this.result = await axClient.cert.getUserCourseCertDetail({ id: this.$route.params.certId });
    },
    // 打开修改证书窗口
    openCertDialog() {
      this.certVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .title {
    margin-top: 12px;
  }
  .el-image{
    max-height: 300px;
    max-width: 150px;
  }
  .switch-btns {
    padding-bottom: 20px;
  }
}
</style>